const ACTIVE = new Set(['queued', 'processing', 'confirmed', 'archiving']);

export interface BulkProgressBatch {
  id: string;
  status: 'processing' | 'complete' | 'blocked';
  bulk_import_receipts: { status: string }[];
}

/** Receipt states are authoritative: batch extraction can be complete before archival. */
export function bulkImportProgress(batches: BulkProgressBatch[]) {
  const active = batches.find(batch => batch.bulk_import_receipts.some(r => ACTIVE.has(r.status)));
  const batch = active || batches[0];
  const allReceipts = batches.flatMap(b => b.bulk_import_receipts);
  return {
    batchId: batch?.id ?? null,
    status: !batch ? null : active ? 'processing' as const
      : batch.bulk_import_receipts.length === 0 ? batch.status
      : batch.bulk_import_receipts.every(r => r.status === 'blocked') ? 'blocked' as const : 'complete' as const,
    hasFailure: !!batch?.bulk_import_receipts.some(r => r.status === 'failed' || r.status === 'blocked'),
    pendingCount: allReceipts.filter(r => ACTIVE.has(r.status)).length,
    archivingCount: allReceipts.filter(r => r.status === 'confirmed' || r.status === 'archiving').length,
  };
}
